"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPlaybackEventCallbacks = createPlaybackEventCallbacks;
function createPlaybackEventCallbacks(contextRef) {
    return {
        video_started: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('video_started', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { playing_content_id: ctx.playingContentId, playing_feature_media_id: ctx.playingFeatureMediaId }));
        },
    };
}
